<template>
    <div class="gastouder-hours-insert">
        <div
            v-if="idStepper > 0"
            class="row mb-3 py-2 toolbar-bg"
        >
            <div class="col-10 col-md-6 col-lg-5 col-xl-4">
                <ul class="stepper px-md-3">
                    <li class="stepper-step"
                        :class="idStepper == '1' ? 'stepper-active' : ''"
                    >
                        <div class="stepper-head">
                            <span class="stepper-head-icon">1</span>
                            <span class="stepper-head-text">Invoeren</span>
                        </div>
                    </li>
                    <li class="stepper-step"
                        :class="idStepper == '2' ? 'stepper-active' : ''"
                    >
                        <div class="stepper-head">
                            <span class="stepper-head-icon">2</span>
                            <span class="stepper-head-text">Controleren</span>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
        <div class="row mb-3 bg-body">
            <div class="col mb-1 mb-md-0">
                <table class="table table-sm responsive-table align-middle caption-top">
                    <caption>
                        <div class="d-flex flex-wrap align-items-center">
                            <span class="fw-bold order-0 me-md-1">{{ this.child.name }}</span>
                            <GastouderStatusBadge
                                v-if="showGastouderPeriodStatus"
                                class="order-0 order-md-2 ms-auto"
                                :status="gastouderPeriodStatus"
                            ></GastouderStatusBadge>
                            <small class="fw-normal order-1 order-md-1">
                                (periode {{ this.gastouderPeriod.startDate }} t/m {{ this.gastouderPeriod.endDate }})
                            </small>
                        </div>
                    </caption>
                    <thead>
                        <tr>
                            <th>Groep</th>
                            <th>Product</th>
                            <th>Prijslijst</th>
                            <th>Status</th>
                            <th>Tijd / Aantal</th>
                            <th v-if="showHourData">Uren</th>
                            <th v-if="canEdit"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <template v-bind:key="date" v-for="date in this.dates">
                            <template v-if="!hideEmptyDates || date.agendaMutations.length > 0">
                                <tr class="table-light" :id="'date-row-' + date.date">
                                    <th
                                        colspan="6"
                                        scope="colgroup"
                                    >
                                        <div class="d-flex justify-content-between align-items-center">
                                            <span>
                                                <span class="fw-normal">{{ date.dayName }}</span>
                                                {{ date.date }}
                                            </span>
                                            <button
                                                v-if="canEdit"
                                                class="btn btn-icon py-0"
                                                type="button"
                                                data-bs-toggle="offcanvas"
                                                data-bs-target="#offcanvasHoursInsert"
                                                aria-controls="offcanvasHoursInsert"
                                                @click="resetFormData(); this.selectedDate = date; setDefaultValues();"
                                            >
                                                <icon name="add" :fontSize="'1.5rem'"></icon>
                                            </button>
                                        </div>
                                    </th>
                                </tr>
                                <tr v-bind:key="agendaMutation" v-for="agendaMutation in date.agendaMutations">
                                    <td
                                        class="text-break"
                                        data-label="Groep"
                                    >{{ agendaMutation.groupName }}</td>
                                    <td
                                        class="text-break"
                                        data-label="Product"
                                    >{{ agendaMutation.productName }}</td>
                                    <td
                                        class="text-break"
                                        data-label="Prijslijst"
                                    >{{ agendaMutation.pricelistName }}</td>
                                    <td data-label="Status">
                                        <template v-if="agendaMutation.productHourly">
                                            <span
                                                v-if="agendaMutation.status === '1'"
                                                class="badge bg-success"
                                            >Aanwezig</span>
                                            <span
                                                v-else
                                                class="badge bg-secondary"
                                            >Afwezig</span>
                                        </template>
                                    </td>
                                    <td :data-label="agendaMutation.productHourly ? 'Tijd' : 'Aantal'">
                                        <div class="d-flex align-items-center justify-content-between align-items-center gap-1 text-nowrap">
                                            <span>{{ agendaMutation.productHourly ? agendaMutation.startTime + ' - ' + agendaMutation.endTime : agendaMutation.quantity }}</span>
                                            <div
                                                v-if="canEdit"
                                                class="d-lg-none"
                                            >
                                                <button class="btn btn-icon py-0">
                                                    <icon
                                                        name="delete"
                                                        @click="deleteMutation(agendaMutation.id)"
                                                        :fontSize="'1.5rem'"
                                                    ></icon>
                                                </button>
                                                <button
                                                    class="btn btn-icon py-0"
                                                    type="button"
                                                    data-bs-toggle="offcanvas"
                                                    data-bs-target="#offcanvasHoursInsert"
                                                    aria-controls="offcanvasHoursInsert"
                                                    @click="setEditData(agendaMutation, date)"
                                                >
                                                    <icon name="edit" :fontSize="'1.5rem'"></icon>
                                                </button>
                                            </div>
                                        </div>
                                    </td>
                                    <td
                                        v-if="showHourData"
                                        data-label="Uren"
                                    >
                                        {{ new Intl.NumberFormat(undefined, { maximumFractionDigits: 2 }).format(agendaMutation.hours) }}
                                    </td>
                                    <td
                                        v-if="canEdit"
                                        class="d-none d-lg-table-cell text-nowrap text-end"
                                    >
                                        <button class="btn btn-icon py-0">
                                            <icon
                                                name="delete"
                                                @click="deleteMutation(agendaMutation.id)"
                                                :fontSize="'1.5rem'"
                                            ></icon>
                                        </button>
                                        <button
                                            class="btn btn-icon py-0"
                                            type="button"
                                            data-bs-toggle="offcanvas"
                                            data-bs-target="#offcanvasHoursInsert"
                                            aria-controls="offcanvasHoursInsert"
                                            @click="setEditData(agendaMutation, date)"
                                        >
                                            <icon name="edit" :fontSize="'1.5rem'"></icon>
                                        </button>
                                    </td>
                                </tr>
                            </template>
                        </template>
                    </tbody>
                </table>
                <div
                    v-if="showHourData"
                    class="fw-bold mb-3"
                >
                    Totaal uren aanwezig: {{ new Intl.NumberFormat(undefined, { maximumFractionDigits: 2 }).format(this.totalHoursPresent) }}<br/>
                    Totaal uren afwezig: {{ new Intl.NumberFormat(undefined, { maximumFractionDigits: 2 }).format(this.totalHoursAbsent) }}
                </div>
            </div>
        </div>

        <div
            class="offcanvas offcanvas-end"
            id="offcanvasHoursInsert"
            tabindex="-1"
            aria-labelledby="offcanvasHoursInsertLabel"
        >
            <div class="offcanvas-header">
                <h5
                    class="offcanvas-title"
                    id="offcanvasHoursInsertLabel"
                >
                    <span class="fw-normal">{{ this.selectedDate.dayName }}</span>
                    {{ this.selectedDate.date }}
                </h5>
                <button
                    class="btn-close"
                    type="button"
                    data-bs-dismiss="offcanvas"
                    aria-label="Close"
                ></button>
            </div>
            <div
                v-if="Object.keys(this.groupData).length > 0 && this.selectedDate"
                class="offcanvas-body"
            >
                <form
                    class="needs-validation"
                    id="mutationForm"
                    novalidate
                >
                    <div class="row mb-3">
                        <label
                            class="col-12 col-lg-2 col-form-label"
                            for="inputGroup"
                        >Groep</label>
                        <div class="col-12 col-lg-10">
                            <select
                                class="form-select"
                                id="inputGroup"
                                v-model="this.selectedIdGroup"
                                @change="resetProductAndPriceList(); setDefaultValues();"
                                required
                            >
                                <option
                                    v-if="Object.keys(groupsForSelectedDate).length !== 1"
                                    value=""
                                >Selecteer</option>
                                <template
                                    v-bind:key="group.id"
                                    v-for="group in Object.values(groupsForSelectedDate)"
                                >
                                    <option :value="group.id">{{ group.name }}</option>
                                </template>
                            </select>
                            <div class="invalid-feedback">
                                Selecteer een groep.
                            </div>
                        </div>
                    </div>
                    <div class="row mb-3">
                        <label
                            class="col-12 col-lg-2 col-form-label"
                            for="inputProduct"
                        >Product</label>
                        <div
                            class="col-12 col-lg-10"
                            id="inputProduct"
                        >
                            <select
                                class="form-select"
                                v-model="this.selectedIdProduct"
                                @change="selectedIdPricelist=''; setDefaultValues(true);"
                                required
                            >
                                <option
                                    v-if="Object.keys(productsForSelectedGroup).length !== 1"
                                    value=""
                                >Selecteer</option>
                                <template v-if="selectedGroup">
                                    <template
                                        v-bind:key="product.id"
                                        v-for="product in Object.values(productsForSelectedGroup)"
                                    >
                                        <option :value="product.id">{{ product.name }}</option>
                                    </template>
                                </template>
                            </select>
                            <div class="invalid-feedback">
                                Selecteer een product.
                            </div>
                        </div>
                    </div>
                    <div class="row mb-3">
                        <label
                            class="col-12 col-lg-2 col-form-label"
                            for="inputPriceList"
                        >Prijslijst</label>
                        <div class="col-12 col-lg-10">
                            <select
                                class="form-select"
                                name="inputPriceList"
                                v-model="this.selectedIdPricelist"
                                required
                            >
                                <option
                                    value="" v-if="Object.keys(priceListsForSelectedProduct).length !== 1"
                                >Selecteer</option>
                                <template v-if="selectedProduct">
                                    <template
                                        v-bind:key="priceList.id"
                                        v-for="priceList in Object.values(priceListsForSelectedProduct)"
                                    >
                                        <option :value="priceList.id">{{ priceList.name }}</option>
                                    </template>
                                </template>
                            </select>
                            <div class="invalid-feedback">
                                Selecteer een prijslijst.
                            </div>
                            <div
                                v-if="hasNoPriceLists"
                                class="alert alert-warning mt-2 mb-0"
                            >
                                Er is geen prijslijst beschikbaar voor dit product.
                            </div>
                        </div>
                    </div>
                    <fieldset
                        v-if="!selectedProduct || selectedProduct.productIsHourly"
                        class="row mb-3"
                    >
                        <legend class="col-12 col-lg-2 col-form-label pt-0">Status</legend>
                        <div class="col-12 col-lg-10">
                            <div class="form-check form-check-inline">
                                <input
                                    class="form-check-input"
                                    id="status1"
                                    type="radio"
                                    name="status"
                                    value="1"
                                    :checked="this.selectedStatus === '1'"
                                >
                                <label
                                    class="form-check-label"
                                    for="status1"
                                >Aanwezig</label>
                            </div>
                            <div class="form-check form-check-inline">
                                <input
                                    class="form-check-input"
                                    id="status2"
                                    type="radio"
                                    name="status"
                                    value="0"
                                    :checked="this.selectedStatus === '0'"
                                >
                                <label
                                    class="form-check-label"
                                    for="status2"
                                >Afwezig</label>
                            </div>
                        </div>
                    </fieldset>
                    <template v-if="selectedProduct">
                        <div
                            v-if="selectedProduct.productIsHourly"
                            class="row mb-3"
                        >
                            <label
                                class="col-12 col-lg-2 col-form-label"
                                for="inputTime"
                            >Tijd</label>
                            <div
                                class="col-12 col-lg-10"
                                id="inputTime"
                            >
                                <div class="d-flex flex-column flex-lg-row gap-2">
                                    <div class="input-group flex-fill">
                                        <span class="input-group-text">Begintijd</span>
                                        <input
                                            class="form-control"
                                            :class="{ 'is-invalid': showTimeMissingError || showTimeOrderError }"
                                            type="time"
                                            id="startTime"
                                            name="startTime"
                                            v-model="this.selectedStartTime"
                                            required
                                        />
                                    </div>
                                    <div class="input-group flex-fill">
                                        <span class="input-group-text">Eindtijd</span>
                                        <input
                                            class="form-control"
                                            :class="{ 'is-invalid': showTimeMissingError || showTimeOrderError }"
                                            type="time"
                                            id="endTime"
                                            name="endTime"
                                            v-model="this.selectedEndTime"
                                            required
                                        />
                                    </div>
                                </div>
                                <div
                                    v-if="showTimeMissingError || showTimeOrderError"
                                    class="invalid-feedback d-block mt-1"
                                >
                                    <span v-if="showTimeMissingError">Vul een begintijd en eindtijd in.</span>
                                    <span v-else>De begintijd moet vóór de eindtijd liggen.</span>
                                </div>
                            </div>
                        </div>
                        <div
                            v-else
                            class="row mb-3"
                        >
                            <label
                                class="col-12 col-lg-2 col-form-label"
                                for="quantity"
                            >Aantal</label>
                            <div class="col-12 col-lg-10">
                                <input
                                    class="form-control"
                                    id="quantity"
                                    type="number"
                                    min="0"
                                    name="quantity"
                                    v-model="this.selectedQuantity"
                                    required
                                >
                                <div class="invalid-feedback">
                                    Vul een aantal in.
                                </div>
                            </div>
                        </div>
                    </template>
                    <div class="row mb-3 justify-content-end">
                        <div class="col-auto">
                            <button
                                class="btn btn-info"
                                type="button"
                                @click="saveMutation()"
                            >Opslaan</button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
    <slot name="bottomButtons" :dates="dates"></slot>
</template>

<script>
import Icon from "@/components/Icon.vue";
import GastouderStatusBadge from "@/views/gastouder/components/GastouderStatusBadge.vue";

export default {
    name: 'GastouderMutationOverview',
    props:  [
        'idGastouderPeriod',
        'idChild',
        'canEdit',
        'idStepper',
        'showSubmittedHours',
        'showHourData',
        'hideEmptyDates',
        'showGastouderPeriodStatus',
        'currentDate'
    ],
    components: {
        Icon,
        GastouderStatusBadge,
    },
    data() {
        return {
            selected: 'optie1',
            child: {},
            gastouderPeriod: {},
            dates: {},
            groupData : {},
            selectedIdAgendaMutation: "",
            selectedDate: "",
            selectedIdGroup: "",
            selectedIdProduct: "",
            selectedIdPricelist: "",
            selectedStatus: "1",
            selectedStartTime: "",
            selectedEndTime: "",
            selectedQuantity: "",
            totalHoursPresent: 0,
            totalHoursAbsent: 0,
            showTimeOrderError: false,
            showTimeMissingError: false,
            showTimeValid: false,
            gastouderPeriodStatus: 0
        };
    },
    created() {
        this.getGastouderPeriodChildData(this.idChild, this.idGastouderPeriod);

        if (this.canEdit) {
            this.getGastouderGroupsData(this.idChild, this.idGastouderPeriod);
        }
    },
    computed: {
        groupsForSelectedDate() {
            return this.groupData?.[this.selectedDate?.date] ?? {};
        },
        selectedGroup() {
            return this.groupsForSelectedDate[this.selectedIdGroup] ?? null;
        },
        productsForSelectedGroup() {
            return this.selectedGroup?.products ?? {};
        },
        selectedProduct() {
            return this.productsForSelectedGroup[this.selectedIdProduct] ?? null;
        },
        priceListsForSelectedProduct() {
            return this.selectedProduct?.priceLists ?? {};
        },
        hasNoPriceLists() {
            return this.selectedProduct !== null
                && Object.keys(this.priceListsForSelectedProduct).length === 0;
        },
    },
    methods: {
        getGastouderPeriodChildData(idChild, idGastouderPeriod) {
            this.$request.post(
                '/gastouder-time-registration/child-gastouderperiod-data',
                {
                    idGastouderPeriod: idGastouderPeriod,
                    idChild: idChild,
                    submitted: this.showSubmittedHours
                }
            )
                .then((response) => {
                    this.child = response.child;
                    this.gastouderPeriod = response.gastouderPeriod;
                    this.dates = response.dates;
                    this.totalHoursPresent = response.totalHoursPresent;
                    this.totalHoursAbsent = response.totalHoursAbsent;
                    this.gastouderPeriodStatus = response.gastouderPeriodStatus;

                    if (this.currentDate) {
                        this.$nextTick(() => {
                            document.getElementById(`date-row-${this.currentDate}`)?.scrollIntoView()
                        })
                    }
                });
        },
        getGastouderGroupsData(idChild) {
            this.$request.post(
                '/gastouder-time-registration/gastouder-group-data',
                {
                    idChild: idChild,
                    idGastouderPeriod: this.idGastouderPeriod
                }
            )
                .then((response) => {
                    this.groupData = response;
                    this.setDefaultValues();
                });
        },
        resetProductAndPriceList() {
            this.selectedIdProduct = "";
            this.selectedIdPricelist = "";
        },
        saveMutation() {
            if(this.validateFields()) {
                this.$request.post(
                    '/gastouder-time-registration/save-mutation',
                    {
                        idMutation: this.selectedIdAgendaMutation,
                        idChild: this.idChild,
                        idGroup: this.selectedIdGroup,
                        idProduct: this.selectedIdProduct,
                        idPricelist: this.selectedIdPricelist,
                        date: this.selectedDate.date,
                        startTime: document.getElementById('startTime')?.value,
                        endTime: document.getElementById('endTime')?.value,
                        quantity: document.getElementById('quantity')?.value,
                        status: document.querySelector('input[name="status"]:checked')?.value,
                    }
                )
                .then(() => {
                    window.location.href = this.$router.resolve({
                        name: 'GastouderHoursInsert',
                        params: {
                            idGastouderPeriod: this.idGastouderPeriod,
                            idChild: this.idChild,
                            date: this.selectedDate.date
                        }
                    }).href;
                });
            }
        },
        deleteMutation(idMutation) {
            if(confirm('Weet je zeker dat je dit wilt verwijderen?')) {
                this.$request.post(
                    '/gastouder-time-registration/delete-mutation',
                    {
                        idMutation: idMutation,
                    }
                ).then(() => {
                    location.reload();
                });
            }
        },
        setEditData(agendaMutation, date) {
            this.selectedIdAgendaMutation = agendaMutation.id;
            this.selectedDate = date;
            this.selectedIdGroup = agendaMutation.idGroup;
            this.selectedIdProduct = agendaMutation.idProduct;
            this.selectedIdPricelist = agendaMutation.idPricelist;
            this.selectedStatus = agendaMutation.status;
            this.selectedStartTime = agendaMutation.startTime;
            this.selectedEndTime = agendaMutation.endTime;
            this.selectedQuantity = agendaMutation.quantity;

            this.setDefaultValues();
        },
        resetFormData() {
            this.selectedIdAgendaMutation = "";
            this.selectedDate = "";
            this.selectedIdGroup = "";
            this.selectedIdProduct = "";
            this.selectedIdPricelist = "";
            this.selectedStatus = "1";
            this.selectedStartTime = "";
            this.selectedEndTime = "";
            this.selectedQuantity = "";
        },
        setDefaultValues() {
            const groups = this.groupsForSelectedDate;

            if (Object.keys(groups).length === 1) {
                this.selectedIdGroup = Object.keys(groups)[0];
            }

            const products = this.productsForSelectedGroup;

            if (this.selectedIdGroup > 0 && Object.keys(products).length === 1) {
                this.selectedIdProduct = Object.keys(products)[0];
            }

            const priceLists = this.priceListsForSelectedProduct;

            if (this.selectedIdProduct > 0 && Object.keys(priceLists).length === 1) {
                this.selectedIdPricelist = Object.keys(priceLists)[0];
            }
        },
        validateFields() {
            const startTime = document.getElementById('startTime');
            const endTime = document.getElementById('endTime');
            const form = document.getElementById('mutationForm');

            this.showTimeOrderError = false;
            this.showTimeMissingError = false;
            this.showTimeValid = false;

            if (startTime && endTime) {
                startTime.setCustomValidity('');
                endTime.setCustomValidity('');

                const startVal = startTime.value;
                const endVal = endTime.value;

                if (!startVal || !endVal) {
                    endTime.setCustomValidity('Vul een begintijd en eindtijd in.');
                    this.showTimeMissingError = true;
                } else if (endVal <= startVal) {
                    endTime.setCustomValidity('De begintijd moet vóór de eindtijd liggen.');
                    this.showTimeOrderError = true;
                } else {
                    this.showTimeValid = true;
                }
            }

            const valid = form.checkValidity();
            form.classList.add('was-validated');
            return valid;
        }
    }
}

</script>

<style scoped>
.toolbar-bg {
    background-color: rgba(0,0,0,.025);
    border-top: 1px solid rgba(0,0,0,.1);
    border-bottom: 1px solid rgba(0,0,0,.1);
}

.btn.btn-icon {
    :not(.btn-check) + &:active {
        --bs-btn-active-color: hsl(206, 90%, 20%);
        --bs-btn-active-border-color: transparent;
    }
}

.stepper {
    display: flex;
    justify-content: space-between;
    padding: 0;
    margin: 0;
    width: 100%;
    list-style: none;
}
.stepper .stepper-step {
    flex: auto;

    &:not(:first-child) .stepper-head:before {
        flex: 1;
        height: 1px;
        width: 100%;
        margin-right: .5rem;
        content: "";
        background-color: hsl(206, 86%, 73%);
    }

    &:not(:last-child) .stepper-head:after {
        flex: 1;
        height: 1px;
        width: 100%;
        margin-left: .5rem;
        content: "";
        background-color: hsl(206, 86%, 73%);
    }
}
.stepper .stepper-head {
    display: flex;
    align-items: center;
    text-decoration: none;
}
.stepper .stepper-head-icon {
    margin-right: .5rem;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 100%;
    font-size: .875rem;
    width: 2rem;
    height: 2rem;
    font-weight: bold;
    background-color: #fff;
    border: 1px solid rgb(0,0,0,.2);
    color: rgb(0,0,0,.5);
}
.stepper .stepper-active {
    .stepper-head-icon {
        background-color: hsl(206, 68%, 90%);
        border-color: hsl(206, 86%, 73%);
        color: hsl(206, 90%, 20%);
    }
    .stepper-head-text {
        font-weight: bold;
        color: hsl(206, 90%, 20%);
    }
}

.responsive-table {
    /* stylelint-disable-next-line selector-max-universal */
    > :not(caption) > * > * {
        &:first-child {
            padding-left: 1rem;
        }
    }
}
.table-light {
    --bs-table-color: #082F4D;
    --bs-table-bg: #f2f9ff;
    --bs-table-border-color: #dee2e6;
}

.offcanvas {
    --bs-offcanvas-width: 90vw;
}

@media (min-width: 992px) {
    .offcanvas {
        --bs-offcanvas-width: 70vw;
        --bs-offcanvas-transition: transform 0.5s ease-in-out;
    }
}

@media (max-width: 768px) {
    .responsive-table {
        /* stylelint-disable-next-line selector-max-universal */
        > :not(caption) > * > * {
            border-bottom-width: 0;
            padding-left: .75rem;
            &:first-child {
                padding-left: .75rem;
            }
        }

        thead {
            display: none;
        }

        tr {
            border: 1px solid #ddd;
        }

        td {
            display: grid;
            gap: .5rem;
            grid-template-columns: 1fr 3fr;

            > .badge {
                justify-self: start;
                align-self: center;
            }
        }

        td::before {
            content: attr(data-label);
            font-weight: bold;
        }
    }
}

</style>